import React from "react";
import "./Finances.css";
import Resources from "../../../Resources/Resources";
import {Container, Row, Col, Modal, Form} from "react-bootstrap";
import {
  APP_SECTION, FINANCES,
  STORAGE_KEYS
} from "../../../scripts/constants";
import PopoverTooltip from "../../../components/PopoverTooltip";
import {saveApplication, startApplication} from "../../../scripts/sync-manager";
import {mygaSession} from "../../../scripts/myga-session";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {NassauLog} from "../../../scripts/myga-utils";
import {PageManager} from "../../../scripts/page-manager";
import Question from "../../../components/Questions/Question";
import {reconcilePaymentsForProducts} from "../../../scripts/validation";
import {QUESTION_RESPONSE_VALUE} from "../../../scripts/myga-model";

class FinancesFL extends React.Component {
  
  constructor(props) {
    super(props);

    // Load the component state from the current application
    this.state = {
      errorMessage: '',
      finances: {...mygaSession.getCurrentAppFinances()}
    };
  
  }
  
  componentDidMount() {
    
    // Get the current application
    let app = mygaSession.getCurrentApp();
    if (app===null) {
      
      // request a new application from the backend
      startApplication()
          .then((data)=>{
            NassauLog("app: " + JSON.stringify(data));
            let finances = {...mygaSession.getCurrentAppFinances()};
            this.setState({
              finances
            })
          })
          .catch((err) => {
            NassauLog(err);
            // TODO: Handle the error. Message popup?
          });
      
    }
  }
  
  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Finances_ErrorMissingInformation
      });
      return false;
    }
    
    return true;
  };
    
  saveApplication = async () => {
    // For Florida, compute the monthly expenses from the annual.
    const finances = this.state.finances;
    if (finances[FINANCES.expensesAnnual]>0) {
      finances[FINANCES.expensesMonthly] = `${finances[FINANCES.expensesAnnual] / 12}`;
    }
    
    // In FL we ask about annuity and insurance separately but want to still capture the "otherContracts" response.
    finances[FINANCES.otherContracts] = (
        finances[FINANCES.annuityOwnership]===QUESTION_RESPONSE_VALUE.yes ||
        finances[FINANCES.lifeOwnership]===QUESTION_RESPONSE_VALUE.yes
    ) ? QUESTION_RESPONSE_VALUE.yes : QUESTION_RESPONSE_VALUE.no;

    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.finances,finances);
  
    await saveApplication(APP_SECTION.finances)
  
    // 2021.09.08.ADivelbiss - Check to see if payments should be cleared.
    // Do this after the finances data are saved
    const nextProductDTOs = reconcilePaymentsForProducts();
    if (nextProductDTOs) {
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs);
      await saveApplication(APP_SECTION.products)
    }
  };

  handleChange = (field) => (e) => {
    let finances = this.state.finances;
    finances[field] = e.target ? e.target.value : e;

    this.setState({
      finances: finances,
      errorMessage:'',
    });
  };
  
  render() {

    return (
    
        <AppContentWrapper
            onBackPressed={this.saveApplication}
            onNextPressed={this.saveApplication}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>
  
          <form className={'needs-validation'}
                ref={(form) => {
                  this.pageForm = form;
                }}>
            <Container>
  
              {/*  Explanation */}
              <Container>
                <Row className="page-question pt-0 mt-0">
                  <Col className=" text-center pb-0">
                    <div>What is your approximate income...&nbsp;
                      {/*<PopoverTooltip content={Resources.Strings.Finances_InfoIncomeAndExpenses}/>*/}
                    </div>
                  </Col>
                </Row>
                <Row className="page-question pt-0 mt-0 text-left">
                  <Col sm={8} className="offset-sm-2 text-left pt-0 pb-4" >
                    <div className={'font-page-small'}><b>Why are we asking? </b>{Resources.Strings.Finances_InfoIncomeAndExpenses}
                    </div>
                  </Col>
                </Row>
              </Container>
          
              {/* Questions */}
              <Question
                containerClass={'offset-sm-2 pb-3'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('annualApplicantIncomeFL')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'offset-sm-2 pb-3'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('annualIncomeFL')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'offset-sm-2 pb-3'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('annualExpenses')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'offset-sm-2 pb-3'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('netWorthFL')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'offset-sm-2 pb-4'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('liquidAssetsFL')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'offset-sm-2 pb-4'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('ageRange')}
                onChange={this.handleChange}/>

              {/* 2022.06.27.ADivelbiss - commenting based on compliance feedback. */}
              {/*<Question*/}
              {/*  containerClass={'pb-1'}*/}
              {/*  data={this.state.finances}*/}
              {/*  question={PageManager.getQuestionByName('hasOtherContracts')}*/}
              {/*  onChange={this.handleChange}/>*/}

              {/*<Row className="page-question pt-0 mt-0 text-left">*/}
              {/*  <Col sm={8} className="offset-sm-2 text-left pt-4 pb-4" >*/}
              {/*    <div className={'font-page-small'}><b>Why are we asking? </b>{Resources.Strings.Finances_InfoIncomeAndExpenses}*/}
              {/*    </div>*/}
              {/*  </Col>*/}
              {/*</Row>*/}

              <Question
                containerClass={'pb-4 mb-4'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('sourceOfIncomeFL')}
                onChange={this.handleChange}/>
              <Question
                  containerClass={'pb-4 pl-4 pl-md-5'}
                  data={this.state.finances}
                  question={PageManager.getQuestionByName('annuityOwnership')}
                  onChange={this.handleChange}/>
              <Question
                containerClass={'pb-4 pl-4 pl-md-5'}
                  data={this.state.finances}
                  question={PageManager.getQuestionByName('lifeOwnership')}
                  onChange={this.handleChange}/>
              <Question
                containerClass={'pb-4 pl-4 pl-md-5'}
                  data={this.state.finances}
                  question={PageManager.getQuestionByName('incomeCoversExpenses')}
                  onChange={this.handleChange}/>
              <Question
                containerClass={'pb-4 pl-4 pl-md-5'}
                  data={this.state.finances}
                  question={PageManager.getQuestionByName('livingExpensesChange')}
                  onChange={this.handleChange}/>
              <Question
                containerClass={'pb-4 pl-4 pl-md-5'}
                  data={this.state.finances}
                  question={PageManager.getQuestionByName('medicalExpensesChange')}
                  onChange={this.handleChange}/>
              <Question
                  containerClass={'pb-4 pl-4 pl-md-5'}
                  data={this.state.finances}
                  question={PageManager.getQuestionByName('incomeCoversExpensesInSurrenderPeriod')}
                  onChange={this.handleChange}/>
              <Question
                containerClass={'pb-4 pl-4 pl-md-5'}
                  data={this.state.finances}
                  question={PageManager.getQuestionByName('hasEmergencyFund')}
                  onChange={this.handleChange}/>

            </Container>
          </form>
  
          <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.showNetWorthMessage}
              onHide={()=>{
                this.setState({
                  showNetWorthMessage: false
                })
              }}
          >
    
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  {MYGAStrings.Finances_ErrorCallForHelp}
                </Col>
              </Row>
    
            </Modal.Body>
  
          </Modal>
          
        </AppContentWrapper>

    );

  }
}

export default FinancesFL;